<mat-toolbar color="primary" class="topbar">
  <button mat-icon-button (click)="toggleSidebar.emit()">
    <mat-icon>menu</mat-icon>
  </button>

  <span class="title">Welcome to Portal</span>
  <span class="spacer"></span>

  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>account_circle</mat-icon>
  </button>

  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="showTutorial()">
      <mat-icon>help</mat-icon>
      <span>View Tutorial</span>
    </button>
    <button mat-menu-item routerLink="/profile">
      <mat-icon>person</mat-icon>
      <span>Profile</span>
    </button>
    <button mat-menu-item (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Logout</span>
    </button>
  </mat-menu>
</mat-toolbar>
